//? Commented code is to show city score per variable and only hide some of the variables score or to blur all the score

import infoIcon from "../../assets/images/infoBlue.svg"
// import { VAR_BLOCKED, INFO_TOOLTIP } from "./utils.js"
import { VAR_BLOCKED, CONNECTIVITY_TRAVEL, GOVERNMENT_LANDSCAPE, INFO_TOOLTIP } from "./utils.js"
import { useAuth } from "../../context/auth-context"
import { useGeneralStates } from "../../context/general-context"
import { forwardRef } from "react"

const VariableRow = forwardRef(({ variable, varPoints, showInfoModal, handleInfoModal }, ref) => {
    const { showSubscribeModal, triggerDetailsSection } = useGeneralStates()
    const { user } = useAuth()
    
    function handleDetailsButton(varId) {
        if (VAR_BLOCKED.includes(varId.toString())) {
            showSubscribeModal()

            return
        }

        triggerDetailsSection(varId)
    }

    function handleInfoTooltip (e) {
        if (e.target.tagName !== "IMG") {
            handleInfoModal(null)
        }
    }

    const variableTextClass = user?.selectedCities?.length === 2 ? "withTwo" : user?.selectedCities?.length === 1 ? "withOne" : ""
    const varPointsFormatted = parseFloat(varPoints)?.toString()
    
    return (
        <div className="variableSection" ref={ref} onClick={handleInfoTooltip}>
            <div className="varTitleSection">
                <img src={infoIcon} alt="Prodensa Teaser" onClick={() => handleInfoModal(variable._id)}/>
                <h5>{variable.title}</h5>
                <button className="criteriaButton" onClick={showSubscribeModal}>Criteria</button>
                <VariableInfoModal variable={variable} showInfoModal={showInfoModal} />
            </div>
            <h5 className="pointsWeight greyText">{varPointsFormatted}</h5>
            <h5 className="pointsWeight greyText">{`${variable.weight}%`}</h5>
            <div className="catCityScoresContainer">
                {user?.selectedCities?.map(city => {
                    const cityResult = user?.result?.find(varResult => varResult.varRefId === variable._id)
                                    ?.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)

                    const cityCost = cityResult?.cost

                    const cityScore = cityResult?.score
                    
                    const dataToShow = VAR_BLOCKED.includes(variable._id.toString()) ? "N/A" : cityCost !== null ? cityScore : "N/A"
                    const dataClass = VAR_BLOCKED.includes(variable._id.toString()) ? "teaserDataHide" : ""

                    // just blur points of connectivity travel and government landscape and allow details button
                    const specialCase = variable._id.toString() === CONNECTIVITY_TRAVEL || variable._id.toString() === GOVERNMENT_LANDSCAPE ? "teaserDataHide" : ""
                    
                    return (
                        <h5 
                            key={`varScore-${variable._id}-${city.datamexico_municipality_id}`} 
                            className={`catCityScore greyText variableText ${variableTextClass} ${dataClass} ${specialCase}`}
                            // className={`catCityScore greyText variableText ${variableTextClass} teaserDataHide`}
                        >
                            {/* N/A */}
                            {dataToShow}
                        </h5>
                    )
                })}
            </div>

            <button className="detailsButton" onClick={() => handleDetailsButton(variable._id)}>Details</button>
        </div>
    )
})

function VariableInfoModal({ variable, showInfoModal }) {
    const infoTooltipClass = `info-tooltip ${showInfoModal === variable._id ? "show" : ""}`
    
    return (
        <div className={infoTooltipClass}>
            {INFO_TOOLTIP.map(item => {
                return (
                    <div className="infoSectionContainer" key={item.id}>
                        <img src={item.image} alt="Prodensa Automation" />
                        <div className="infoContainer">
                            <h5>{item.title}</h5>
                            <span>{variable?.information?.[item.accessKey]}</span>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default VariableRow